<template>
    <div class="flex flex-col items-center justify-center min-h-screen p-4 text-center bg-gray-50 dark:bg-gray-900">
        <div class="text-6xl md:text-8xl font-black colorful mb-8">Update</div>
        <h1 class="text-3xl font-bold text-slate-700 dark:text-slate-200 mb-4">App Update Required</h1>
        <p class="text-lg text-slate-500 dark:text-slate-400 mb-8 max-w-md">
            The application has been updated with new features and fixes. Please reload to continue using the app.
        </p>
        <button @click="reloadPage" class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg transition-colors text-lg">
            Reload App Now
        </button>
    </div>
</template>
<script setup>
const reloadPage = () => {
    // Add cache buster and reload the page
    const url = new URL(window.location.href);
    url.searchParams.set('u', Date.now().toString());
    window.location.replace(url.toString());
}
</script>
<style scoped>
.colorful {
    background: linear-gradient(90deg, #62bafa, #5145cd);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
